module.exports = __webpack_public_path__ + "static/media/home4.ed9ec73b.jpg";